import type { GraphState, PresetDraftState } from 'components/Graph/GraphState';
import type { UpdateRecipe } from 'utils/react/StateProxy';

export function setPresetDraftState(
  state: PresetDraftState,
): UpdateRecipe<GraphState> {
  return (draft) => {
    if (state !== 'idle' && draft.layoutSettings.presetDraftState !== 'idle') {
      throw new Error(
        `Active preset is already in ${draft.layoutSettings.presetDraftState}, cannot switch to ${state}`,
      );
    }
    draft.layoutSettings.presetDraftState = state;
  };
}
